import { useMemo } from 'react'

import { useHealthSignal } from '@krp/client-runtime'
import { sourceHealth, type MyResource } from '@krp/platform-ui'

import { isSourceDown, sourceTitleOf } from './resourceTiles'

/**
 * Связь с источником — сигналом в точку «Связь» шапки (RP-UI-LINK, шаг 3), пока компонент смонтирован. Ничего не рисует:
 * о связи на экране говорит только точка. Данные — `MyResource.contact` из «моих ресурсов»; живое событие
 * `resource.connection.changed` перечитывает их, и сигнал меняется без перезагрузки раздела.
 */
export function SourceHealthSignal({ resource }: { resource: MyResource }) {
  const signal = useMemo(
    () => sourceHealth(resource.contact, { id: `source:${resource.id}`, title: sourceTitleOf(resource) }),
    [resource],
  )
  useHealthSignal(signal)
  return null
}

/**
 * Сигналы источников, которые не отвечают, — для экранов выбора источника: плитка ставит только красную метку, а что
 * именно случилось, точка «Связь» объясняет мини-окном. Исправные источники точку не шумят.
 */
export function DownSourceSignals({ resources }: { resources: readonly MyResource[] }) {
  return (
    <>
      {resources.filter(isSourceDown).map((resource) => (
        <SourceHealthSignal key={resource.id} resource={resource} />
      ))}
    </>
  )
}
